import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { salesAnalysisDataConnect } from "../../../../../data_connect/salesAnalysisDataConnect";
import { getEndDate, getStartDate, getTimeDiffWithUTC, setPlusDate } from "../../../../../utils/dateFormatUtils";
import useRouterHookV2 from "../../../../../hooks/router/useRouterHookV2";
import defaultErrorHandler from "../../../../../handler/dataConnectErrorHandler";

export default function useCategoryOptionAnalysisHook({ productAnalysis }) {
    const workspaceRedux = useSelector(state => state.workspaceRedux);
    
    const [isLoading, setIsLoading] = useState(false);
    const [analysis, setAnalysis] = useState(null);

    const router = useRouterHookV2();

    useEffect(() => {
        async function searchOptionPerformance() {
            let searchStartDate = setPlusDate(new Date(), 0, 0, -13);
            let searchEndDate = new Date();
            let productIds = productAnalysis?.content.map(r => r.productId);
            let undefinedProductFlag = productIds.includes(null);
            let searchProductIds = productIds.filter(r => r);
            let periodType = router.query.periodType ?? 'registration';
            let categoryIds = router.state?.productSubCategoryIds;
            let subCategoryIds = router.state?.productSubCategoryIds;

            // 검색 상품이 0개 일 때 옵션성과 조회 X
            if(searchProductIds.length === 0) {
                return;
            }
            
            if (router.query.startDate && router.query.endDate) {
                searchStartDate = new Date(router.query.startDate);
                searchEndDate = new Date(router.query.endDate);
            }
            
            let body = {
                startDate: getStartDate(searchStartDate),
                endDate: getEndDate(searchEndDate),
                utcHourDifference: getTimeDiffWithUTC(),
                includeUndefinedProductFlag: undefinedProductFlag,
                productIds: searchProductIds,
                productCategoryIds: categoryIds,
                productSubCategoryIds: subCategoryIds,
                periodType
            }
            
            let headers = {
                wsId: workspaceRedux?.workspaceInfo.id
            }

            await reqSearchChannelOptionAnalysisByProduct(body, headers);
        }

        if(productAnalysis?.content?.length > 0) {
            searchOptionPerformance();
        }
    }, [productAnalysis])

    const toggleIsLoading = (loading) => {
        setIsLoading(loading);
    }

    const reqSearchChannelOptionAnalysisByProduct = async (body, headers) => {
        toggleIsLoading(true);
        await salesAnalysisDataConnect().searchOptionAnalysisByProduct(body, headers)
            .then(res => {
                if (res.status === 200) {
                    setAnalysis(res.data.data);
                }
            })
            .catch(err => defaultErrorHandler(err))
        toggleIsLoading(false);
    }

    return {
        isLoading,
        analysis
    }
}